import React, { useEffect } from 'react';
import styled from 'styled-components';
import { PaymentFormProps } from './CreditCardForm';
import AddressComplete from '../../../../../LoginModal/pages/AddressComplete';
import { Wallet } from '../../../../../../providers/DonorProvider/interfaces';
import { Text } from '../../../common/Text/Text';
import { DISABLE_CAPTCHA } from '../../../../../LoginModal/pages/Landing/api';
import ReCaptchaV3 from '../../../../../Wrappers/ReCaptchaV3';
import { useAddCardLogic } from './useAddCardLogic';
import { AddCardResponse } from './api';
import { GivingApiResponse } from '../../../../../../utils/makeApiRequest';
import { RequestState } from '../../../../../../hooks/useRequestState';
import { usePaymentOutageContext } from '../../../../../../providers/PaymentOutageProvider';

export const AddCardExtraComponent: React.FC<{
  handleClose: () => unknown;
  requestState: RequestState<GivingApiResponse<AddCardResponse>>;
}> = ({ requestState, handleClose }) => {
  const { handleOpen } = usePaymentOutageContext();

  useEffect(() => {
    const isPaymentOutage =
      requestState.type === 'REQUEST_ERROR' &&
      requestState.error?.response?.status === 1409;
    if (isPaymentOutage) {
      handleOpen();
      handleClose();
    }
  }, [requestState, handleOpen]);

  return (
    <>
      {requestState.type === 'REQUEST_ERROR' && (
        <Text
          color={'utilityError'}
          className={'error'}
        >
          {requestState.error.message}
        </Text>
      )}
      {!DISABLE_CAPTCHA && <ReCaptchaV3 className={'recaptcha'} />}
    </>
  );
};

const StyledAddress = styled(AddressComplete)`
  padding-top: 18px;
  .error {
    margin-top: 18px;
  }
`;

const AddressCompleteForm: React.FC<
  PaymentFormProps & {
    addCard: (card: Wallet) => unknown;
    handlePaymentModalClose: () => unknown;
  }
> = ({ user, setRoute, setUser, addCard, handlePaymentModalClose }) => {
  const { requestState, handleSubmit } = useAddCardLogic({
    eventName: 'AddressCompleteForm',
    user,
    addCard,
    setRoute,
    setUser,
    handlePaymentModalClose
  });

  return (
    <StyledAddress
      user={user}
      isLoading={requestState.type === 'REQUEST_START'}
      closeModal={() => null}
      questionText={'What’s your billing address?'}
      buttonText={'Add card'}
      onNext={handleSubmit}
      page={'ADDRESS_COMPLETE'}
      ExtraComponent={() => (
        <AddCardExtraComponent
          requestState={requestState}
          handleClose={handlePaymentModalClose}
        />
      )}
    />
  );
};

export default AddressCompleteForm;
